const GET_BATCH_ASSIGNMENTS = `query GetAssignments($entityIdList: [ID!]!, $entityType: Entity!, $dateStart: String, $dateEnd: String, $districtId: ID!, $schoolId: ID!, $limit: Int, $assignmentType: [String], $periodIds: [ID], $entityTypeFilter: [Entity], $tags: [String]) {
  assignments(entityId: $entityIdList, entityType: $entityType, filter: {dateFrom: $dateStart, dateTo: $dateEnd, status: [ASSIGNED,IN_PROGRESS,COMPLETE,DONE,ERROR],defaultEntities: [{entityType: DISTRICT, entityId: $districtId},{entityType: SCHOOL, entityId: $schoolId},{entityType: CLASS, entityId: 12345}], limit: $limit, assignmentType: $assignmentType, periodIds: $periodIds, entityType: $entityTypeFilter, tags: $tags }) {
  assignments {
          assignmentId
          assignmentType
          createdAt
          entityId
          entityType
          parentId
          status
          dateFrom
          dateTo
          periodId
          manifest {
            activityType
            locale
            sequence
            status
            activity {
              activityId
              type
              status
              displayStatus
              createdAt
              tags
            }
          }
        }
        entityId
      }
}
`;

export default GET_BATCH_ASSIGNMENTS;
